import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoaderCircle } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export const AuthCallback = () => {
  const { googleLogin, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const user = await googleLogin(sessionId);
        toast.success(`Selamat datang, ${user.name}`);
        navigate("/", { replace: true });
      } catch (err) {
        toast.error(formatApiError(err, "Login Google gagal. Silakan coba lagi."));
        await logout();
        navigate("/masuk", { replace: true });
      }
    })();
  }, [googleLogin, logout, navigate, location.hash]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center gap-2 text-sm text-slate-500" data-testid="auth-callback">
      <LoaderCircle className="h-5 w-5 animate-spin text-emerald-600" /> Memproses login Google...
    </div>
  );
};
